import { makeStyles } from '@mui/styles';

const muiStyles = makeStyles(() => ({
    root: {
        width: 'auto' as 'auto',
        marginTop: '1rem',
        marginRight: '1.5rem'
    },
    itemsSelect: { width: '5rem' },
    itemsText: {
        alignSelf: 'center' as 'center',
        marginLeft: '.75rem'
    }
}));

export default muiStyles;